import { SERVICE_ROUTE_NAME } from '@/libs/route-name';

export const serviceRoute = () => {
    return {
        name: SERVICE_ROUTE_NAME.SERVICE,
        path: 'service',
        component: () => import('@/pages/service/index.vue'),
    };
};
